import React, { useState } from 'react'
import Avatar from '@material-ui/core/Avatar'
// import Button from '@material-ui/core/Button'
import Button from 'components/button/RegularButton.jsx'
import CssBaseline from '@material-ui/core/CssBaseline'
import TextField from '@material-ui/core/TextField'
import Box from '@material-ui/core/Box'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import { AddAlert } from '@material-ui/icons'
import Snackbar from '../snackbar/Snackbar'
import { initialNotificationState } from '../utils/state/ApplicationState'
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router'
import { getApiUrl } from '../../api/api'

// function Copyright() {
//   return (
//     <Typography variant="body2" color="textSecondary" align="center">
//       Powered by Netzwerkreferat
//     </Typography>
//   )
// }

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}))

export default function PasswordReset() {
  const classes = useStyles()

  const [username, setUsername] = useState('')
  const [notification, setNotification] = useState(initialNotificationState)

  const hist = useHistory()
  let search = useLocation().search
  let redirect
  if (search != null) redirect = search.split('=')[1]

  const loginLink = () => hist.push('/login')

  const submitForm = (e) => {
    e.preventDefault()

    getApiUrl()
      .get(`/public/password/reset/${username}`)
      .then(function(response) {
        setNotification({
          open: true,
          message: response.data,
          color: 'success',
        })
        setUsername('')
        setTimeout(function() {
          redirect != null ? hist.push(redirect) : hist.push('/login')
        }, 6000)
      })
      .catch(function(error) {
        if (error.response !== undefined) {
          setNotification({
            open: true,
            message: error.response.data.message,
            color: 'danger',
          })
        } else {
          setNotification({
            open: true,
            message: 'Bitte den Admin kontaktieren.',
            color: 'danger',
          })
        }
      })
  }

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline/>
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon/>
        </Avatar>
        <Typography component="h1" variant="h5">
          Passwort zurücksetzen
        </Typography>
        <form className={classes.form} noValidate>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="username"
            label="Username/Email"
            name="username"
            autoComplete="email"
            autoFocus
            value={username}
            onChange={(e) => setUsername(e.currentTarget.value)}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            onClick={(e) => {
              submitForm(e)
            }}>
            zurücksetzen
          </Button>
        </form>
      </div>
      <Box mt={3}>
        <div align="center">
          <a href={loginLink} onClick={loginLink}>
            {' '}
            zum Login{' '}
          </a>
        </div>
      </Box>
      <Snackbar
        place="br"
        color={notification.color}
        icon={AddAlert}
        message={notification.message}
        open={notification.open}
        closeNotification={() =>
          setNotification({
            open: false,
            message: '',
            color: '',
          })
        }
        close
      />
    </Container>
  )
}
